<!-- <div class="flex items-start"> -->
<div class="flex">
  <div class="relative mr-2.5">
    <input
      *ngIf="control; else templateDriven"
      type="checkbox"
      id="{{ id }}"
      [checked]="checked"
      class="peer relative h-5 w-5 cursor-pointer appearance-none rounded-sm border-2 border-gray-500 transition-all checked:border-primary checked:bg-primary checked:before:bg-primary {{
        isVisuallyDisabled ? 'opacity-50' : ''
      }}"
      (click)="onClick($event)"
      [formControl]="control"
    />

    <ng-template #templateDriven>
      <input
        type="checkbox"
        id="{{ id }}"
        [checked]="checked"
        class="peer relative h-5 w-5 cursor-pointer appearance-none rounded-sm border-2 border-gray-500 transition-all checked:border-primary checked:bg-primary checked:before:bg-primary {{
          disabled ? 'opacity-50' : ''
        }}"
        (click)="onClick($event)"
        [disabled]="disabled"
      />
      <!-- [(ngModel)]="value" -->
    </ng-template>

    <span
      class="pointer-events-none absolute left-2/4 top-2.5 -translate-x-2/4 -translate-y-2/4 text-white opacity-0 transition-opacity peer-checked:opacity-100"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-3.5 w-3.5"
        viewBox="0 0 20 20"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="1"
      >
        <path
          fill-rule="evenodd"
          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
          clip-rule="evenodd"
        ></path>
      </svg>
    </span>
  </div>
  <label
    title="{{ label }}"
    class="mt-[-2.3px] cursor-pointer select-none text-base"
    htmlFor="{{ id }}"
    >
    @if(fontSize) {
      <app-typography [variant]="'extraSmall'">{{label}}</app-typography>
    } @else{
      {{ label }}

    }
  </label>
</div>
